// extracted by mini-css-extract-plugin
export var container = "styles-module--container--rhc7s";
export var desktop = "1340px";
export var dockedBottom = "styles-module--dockedBottom--FDOPr";
export var dockedTop = "styles-module--dockedTop--+d1JK";
export var figure = "styles-module--figure--Yu1-r";
export var giant = "2200px";
export var grid = "styles-module--grid--bfVvW";
export var image = "styles-module--image--rurEu";
export var largeDesktop = "1600px";
export var largeMobile = "500px";
export var largeTablet = "1025px";
export var mobile = "400px";
export var padded = "styles-module--padded--HN9BQ";
export var smallDesktop = "1260px";
export var smallMobile = "340px";
export var smallTablet = "660px";
export var tablet = "769px";